import Entity from "../../Entity";
import { EnemyConfig } from "./consts";
import { EnemyInputController } from "@controllers/input";
import { Skorpion, Uzi } from "../../guns";
import AssetLoader from "@managers/loaders";
import EnemyFiniteStateMachine from "./fsm";
import EnemyAnimationController from "./animations";
import { GunController } from "@controllers/guns";
import { ModelMeshController } from "@controllers/mesh";
class Enemy extends Entity {
    /**
     * Enemy object.
     * @param scene the rendering scene.
     * @param physicsWorld the physics world.
     * @param position The position at which to spawn the enemy.
     * @param rotation The enemy's rotation.
     */
    constructor(scene, physicsWorld, position, rotation) {
        const assetLoader = AssetLoader.getInstance();
        const config = EnemyConfig;
        config.POSITION = position;
        config.ROTATION = rotation;
        const meshController = new ModelMeshController(assetLoader.getEnemyAssets.modelLoader, config.RECEIVE_SHADOW, config.CAST_SHADOW);
        const gunController = new GunController(new Uzi(assetLoader), new Skorpion(assetLoader));
        const inputController = new EnemyInputController(rotation);
        const animationController = new EnemyAnimationController(assetLoader, meshController.getMesh);
        const finiteStateMachine = new EnemyFiniteStateMachine(animationController);
        super(config, scene, physicsWorld, meshController, inputController, finiteStateMachine, gunController);
    }
    get getInputController() {
        return this.characterController.getInputController;
    }
}
export { Enemy };
